import logo from "../assets/icons/logo.svg";
import imagePH from "../assets/image-place-holder.png"
// import avatar from "../assets/Avatar.png";
import avatar2 from "../assets/Avatar2.png";
import showroomMap from "../assets/showroom-map.png";
import product from "../assets/product-img.png";
import aiImage from "../assets/AI-image.png";

import hand from "../assets/icons/hand-icon.svg"
import arrowCircle from "../assets/icons/arrow-circle-right.svg"
import sparkles from "../assets/icons/sparkles.svg"
import arrowUp from "../assets/icons/arrow-up-main.svg"
import arrowDown from "../assets/icons/Icon-arrow-down.svg"
import triangleDown from "../assets/icons/triangle-down.svg"
import search from "../assets/icons/search-icon.svg"
import plus from "../assets/icons/plus-icon.svg"
import dropzone from "../assets/icons/dropzone-icon.svg";
import bin from "../assets/icons/bin-icon.svg";
import edit from "../assets/icons/edit-icon.svg";
import navigation from "../assets/icons/Navigation.svg";
import heart from "../assets/icons/yellow-heart.svg";
import dividerStraight from "../assets/icons/Divider-straight.svg";
import notification from "../assets/icons/notifications.svg";
import notificationDot from "../assets/icons/notifications-with-dot.svg";
import close from "../assets/icons/close.png";
import google from "../assets/icons/google-icon.svg";
import dragPan from "../assets/icons/drag_pan-icon.svg";
import gear from "../assets/icons/gear-icon.svg";
import circlePinGreen from "../assets/icons/circle-pin-green.svg";
import circleArrowUp from "../assets/icons/circle-arrow-up.svg";
import upload from "../assets/icons/upload.svg";
import image from "../assets/icons/image.svg";
import circlePlusPlaceholder from "../assets/icons/circle-plus-placeholder.svg";

import Battery_I from "../assets/icons/BatteryIcon_I.svg";
import Battery_II from "../assets/icons/BatteryIcon_II.svg";
import Battery_III from "../assets/icons/BatteryIcon_III.svg";
import Battery_IV from "../assets/icons/BatteryIcon_IV.svg";
import Battery_V from "../assets/icons/BatteryIcon_V.svg";


import greyCircle from "../assets/icons/grey-circle-icon.svg";
import yellowCircle from "../assets/icons/yellow-circle-icon.svg";
import greenCircle from "../assets/icons/green-circle-icon.svg";

export const logoImg: string = logo;
export const imagePlaceHolder: string = imagePH;
export const avatarImg: string = avatar2;
export const showroomMapImg: string = showroomMap;
export const productImg: string = product;
export const aiImageImg: string = aiImage;

export const handIcon: string = hand;
export const arrowCircleIcon: string = arrowCircle;
export const sparklesIcon: string = sparkles;
export const arrowUpIcon: string = arrowUp;
export const arrowDownIcon: string = arrowDown;
export const triangleDownIcon: string = triangleDown;
export const searchIcon: string = search;
export const plusIcon: string = plus;
export const dropzoneIcon: string = dropzone;
export const binIcon: string = bin;
export const editIcon: string = edit;
export const navigationIcon: string = navigation;
export const heartIcon: string = heart;
export const dividerStraightIcon: string = dividerStraight;
export const notificationIcon: string = notification;
export const notificationDotIcon: string = notificationDot;
export const closeIcon: string = close;
export const googleIcon: string = google;
export const dragPanIcon: string = dragPan;
export const gearIcon: string = gear;
export const circlePinGreenIcon: string = circlePinGreen;
export const circleArrowUpIcon: string = circleArrowUp;
export const uploadIcon: string = upload;
export const imageIcon: string = image;
export const circlePlusPlaceholderIcon: string = circlePlusPlaceholder;

export const BatteryIcon_I: string = Battery_I;
export const BatteryIcon_II: string = Battery_II;
export const BatteryIcon_III: string = Battery_III;
export const BatteryIcon_IV: string = Battery_IV;
export const BatteryIcon_V: string = Battery_V;


export const greyCircleIcon: string = greyCircle;
export const yellowCircleIcon: string = yellowCircle;
export const greenCircleIcon: string = greenCircle;